import SolutionContent from "components/SolutionsContent/solutionsContent.component";

function Solutions() {
  return <SolutionContent />;
}

export default Solutions;
